import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { CRM_PIPELINE_API } from '../api/crm-pipeline-api'
import { PipelineCreateInterface, PipelineInterface } from '../types/pipeline-interface'

export const useCreatePipeline = () => {
  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.post, PipelineInterface>({
    method: RequestMethodsEnum.post,
  })
  return {
    createPipeline: (data: PipelineCreateInterface) => fetcher(`${CRM_PIPELINE_API}`, data),
    isFetching,
  }
}
